import { z } from 'zod';
import { uuidV7Schema } from '../uuid.js';
/**
 * D4 — ce que l'endpoint de dépôt rend à la tablette : l'identifiant de la proposition rangée
 * en file de validation, et **si cet envoi avait déjà été reçu**.
 *
 * `proposalId` est généré côté **serveur**, contrairement à la plupart des identifiants de ce
 * modèle (M7) : la clé que la tablette porte est `idempotencyKey`, et c'est elle qui rend le
 * rejeu inoffensif. La proposition, elle, naît à l'ingestion.
 *
 * `replayed` n'est pas cosmétique : c'est ce qui permet à l'outbox de distinguer « mon envoi a
 * bien été enregistré cette fois » de « il l'était déjà », donc de vider sa file sans se
 * demander si elle a créé un doublon. Le champ est **exigé** — laisser `undefined` passer pour
 * « non » ferait mentir le seul signal que le terrain a sur son propre état.
 */
export const depositResultSchema = z.object({
    proposalId: uuidV7Schema,
    replayed: z.boolean(),
});
//# sourceMappingURL=deposit-result.js.map